import type { SxProps, Theme } from '../../../themes/themes';

export const getStyles = (theme: Theme, underlined: boolean): { [key: string]: SxProps } => {
  return {
    icon: {
      color: theme.palette.grey['dark'],
      verticalAlign: 'text-top',
      fontSize: theme.spacing(5),
      [theme.breakpoints.up('lg')]: {
        fontSize: theme.spacing(6),
      },
    },
    link: {
      minHeight: theme.spacing(6),
      marginBottom: theme.spacing(6),
      justifyContent: 'space-between',
      [theme.breakpoints.up('md')]: {
        minHeight: theme.spacing(8),
        minWidth: '240px',
      },
      ':focus-visible': {
        outline: 'none',
      },
      '&:focus': {
        '.MuiTypography-button': {
          color: theme.palette.text.primary,
          '&::after': {
            opacity: 1,
          },
        },
      },
      '&:hover': {
        '.MuiTypography-button': {
          color: theme.palette.text.primary,
          '&::after': {
            opacity: 1,
          },
        },
      },
    },
    inner: {
      alignSelf: 'center',
      position: 'relative',
      color: underlined ? theme.palette.text.primary : theme.palette.grey['dark'],
      '&::after': {
        content: '""',
        position: 'absolute',
        left: 0,
        bottom: '-2px',
        height: '2px',
        opacity: underlined ? 1 : 0,
        transition: theme.transitions.create('opacity', {
          duration: '0.26s',
        }),
        background: theme.palette.grey.A100,
        width: '100%',
      },
    },
  };
};
